var e="@hpstellar/core/reviews",r={getLabel:function(e){return"Rating: ".concat(e,"/5")}};export{e as reviewsTestId,r as reviewsTranslations};
